const urlApiGetWords = `https://oclintapi.elint.services/storage/get-snd-records`;
const urlGetPdf = `https://oclintapi.elint.services/files/download-url`;
const urlApiListAll = `https://oclintapi.elint.services/storage/list-files`;

export { urlApiGetWords, urlGetPdf, urlApiListAll };
